/* Centralized breakpoints in pure CSS, preserving JS imports via :export */

:root {
  --tablet-screen-breakpoint: 1512px;
  --mobile-screen-breakpoint: 1024px;
  --not-supported-screen-breakpoint: 360px;
}

/* CSS Modules export for TypeScript runtime usage */
:export {
  tabletBreakpoint: 1512px;
  mobileBreakpoint: 1024px;
  noSupportedBreakpoint: 360px;
}
